const styles = theme => ({
  imageContent: {
    height: 'auto',
    clip:'initial',
  },
  container: {
    backgroundColor: '#fffff',
    overflow: 'hidden',
    width: 'auto',
    height: 'auto',
    zIndex: 8000,
  },
  imageSize: {
    height:200,
    width:200,
  },
  upIndex: {
    zIndex: 100000,
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Candidate/components/User/scenes/Core/components/Images/styles.js